import { format } from "date-fns";

export function formatAppDateTime(v: string | null): string {
  if (!v) return "";
  if (!v.includes("T")) return v;
  return format(new Date(v), "dd/MM/yyyy HH:mm:ss");
}

export function formatAppDate(v: string | null): string {
  if (!v) return "";
  return format(new Date(v), "dd/MM/yyyy");
}
